import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class InvoiceStatusReferenceService extends BaseReferenceService {
  constructor() {
    super('InvoiceStatusReference');
  }
}
